import {
    APPLICATION_CONTEXT_UPDATE,
    APPLICATION_CONTEXT_UPDATE_CHANNEL,
    APPLICATION_CONTEXT_UPDATE_SOLARSPECIALIST,
    APPLICATION_CONTEXT_UPDATE_CAMPAIGN,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const dotProp = require('dot-prop-immutable');

const initialState = appInitialState.applicationContext;

function applicationContextReducer(state = initialState, action) {

    let dataPath = '';

    switch (true) {

        case (action.type === STORE_RESET):

            // nothing happens here: the application context must be kept as is when the store is reset
            break;

        case (action.type === APPLICATION_CONTEXT_UPDATE):

            state = action.payload;
            break;

        case (action.type === APPLICATION_CONTEXT_UPDATE_CHANNEL):

            dataPath = 'ch';
            state = dotProp.set(state, dataPath, action.payload.ch);
            break;

        case (action.type === APPLICATION_CONTEXT_UPDATE_SOLARSPECIALIST):

            dataPath = 'ss';
            state = dotProp.set(state, dataPath, action.payload.ss);
            break;

        case (action.type === APPLICATION_CONTEXT_UPDATE_CAMPAIGN):

            dataPath = 'cmp';
            state = dotProp.set(state, dataPath, action.payload.cmp);
            break;

        default:
            
    }

    return state;

};

export default applicationContextReducer;